import React from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import AttendanceAction from "store/attendance-resource/actions"

const LeftCard = ({ validation }) => {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  React.useEffect(() => {
    dispatch(AttendanceAction.getAssignmentList(callbackGetAssignmentList))
  }, [])

  const callbackGetAssignmentList = data => {
    validation.setFieldValue("assignments", data)
  }

  return (
    <Col sm="6">
      <h4 className="text-dark">今週の作業</h4>
      <Card className="px-2 pt-3 pb-4">
        <CardBody>
          {store.attendance.assignmentList.loading ? (
            <p>Loading...</p>
          ) : (
            validation.values.assignments.map((i, k) => (
              <FormGroup key={k} check className="mb-1">
                <Input
                  name={`assignments.${k}.checked`}
                  type="checkbox"
                  // checked={i.checked}
                  value={i.checked}
                  onChange={e => {
                    validation.setFieldValue(
                      `assignments.${k}.checked`,
                      !i.checked
                    )
                  }}
                />
                <Label check>
                  {i.orderNumber}/{i.customerName}/{i.productName}{" "}
                  {i.basting ? "(仮縫い)" : ""}
                </Label>
              </FormGroup>
            ))
          )}
        </CardBody>
      </Card>
      <Card className="p-1">
        <CardHeader className="bg-white pb-0">検品合計時間</CardHeader>
        <CardBody className="pt-3 pb-1">
          <Row>
            <Col sm="12">
              <h6>検品時間</h6>
            </Col>
            <Col sm="6">
              <FormGroup row>
                <InputGroup>
                  <Input
                    name="inspectionHour"
                    className="form-control"
                    value={validation.values.inspectionHour || ""}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.inspectionHour &&
                      validation.errors.inspectionHour
                        ? true
                        : false
                    }
                  />
                  <InputGroupText>時間</InputGroupText>
                  {validation.touched.inspectionHour &&
                  validation.errors.inspectionHour ? (
                    <FormFeedback type="invalid">
                      {validation.errors.inspectionHour}
                    </FormFeedback>
                  ) : null}
                </InputGroup>
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup row>
                <InputGroup>
                  <Input
                    name="inspectionMinute"
                    className="form-control"
                    value={validation.values.inspectionMinute || ""}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.inspectionMinute &&
                      validation.errors.inspectionMinute
                        ? true
                        : false
                    }
                  />
                  <InputGroupText>分</InputGroupText>
                  {validation.touched.inspectionMinute &&
                  validation.errors.inspectionMinute ? (
                    <FormFeedback type="invalid">
                      {validation.errors.inspectionMinute}
                    </FormFeedback>
                  ) : null}
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default LeftCard
